import { render } from "./InstanceInfoTable.vue?vue&type=template&id=72451810&scoped=true&ts=true"
import script from "./InstanceInfoTable.ts?vue&type=script&lang=ts"
export * from "./InstanceInfoTable.ts?vue&type=script&lang=ts"

import "./InstanceInfoTable.vue?vue&type=style&index=0&id=72451810&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72451810"]])

export default __exports__